<template>
  <el-form :rules="rules" :model="forgetForm" ref="checkForm" class="check-container" label-position="left"
    label-width="0px" v-loading="loading">
    <h3 class="forget">{{$t("check.forget")}}</h3>
    <p class="hint">{{$t("check.hint")}}</p>
    <el-form-item style="width: 100%">
      <el-button type="primary"  @click="checkSubmit()" style="width: 90%">{{$t("check.login_page")}}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
  import {
    postRequest
  } from "../utils/api";
  import {
    putRequest
  } from "../utils/api";
  import {
    isIntersect
  } from "../utils/utils";
  export default {
    data() {
      return {
        code:"",
        checked: true,
        loginForm: {
          username: "",
          password: ""
        },
        loading: false
      };
    },
    methods: {
      jump(path) {
        this.$router.replace(path);
      },
      clearAllCookie() {
        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        if (keys) {
          for (var i = keys.length; i--;)
            document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
        }
      },
      checkSubmit() {
        var str = window.location.href;
        var code = str.split("https://www.hrbox.jp/senseSys/#/check?code=")[1];
        var _this = this;
        this.loading = true;
        postRequest("/checkCode", {
          code: code
        }).then(
          resp => {
            
            _this.loading = false;

            var json = resp.data;
            if (json.status == "success") {
              // _this.clearAllCookie();
              _this.$alert(this.$t("check.mailed"), this.$t("check.success"));

              _this.$router.replace({
                path: "/"
              });
            }
          }
        );
      }
    },
    created() {
    // this.axios
    //   .post("/pageComInfo")
    //   .then((response) => {
        
    //     console.log(response.data);
    //     this.tableData = response.data;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  };
</script>
<style scoped>
  .check-container {
    border-radius: 15px;
    background-clip: padding-box;
    margin: 180px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .check {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }

  .hint {
    color: gray;
    font-size: 75%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Check.vue